import React from 'react';
import { ReturnToDraftButton } from '../return-to-draft-button';
import { SharedButtonsClassNames } from '../SharedButtonsClassNames';

export const ArchivedSharedButtons: React.FC<SharedButtonsClassNames> = ({
  returnToDraftClassName,
}) => <ReturnToDraftButton className={returnToDraftClassName} />;
